import axios from 'axios';
import userStore from 'stores/user.store';
import { noAuthPaths } from 'config.json';
import storage from 'libs/storage';
import apolloClient from 'libs/apollo/apollo.lib';
import layoutStore from 'stores/layout.store';

const axiosBarwisInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Add a request interceptor
axiosBarwisInstance.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const platform = layoutStore.getPlatform();
    if (platform === 'web') {
      config.withCredentials = true;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosBarwisInstance.interceptors.response.use(
  function (response) {
    const platform = layoutStore.getPlatform();
    if (platform === 'web') {
      response.config.withCredentials = true;
    }
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.status === 401) {
      userStore.setIsAuthenticated(false);
    }
    return Promise.reject(error);
  }
);

const axiosBarwisSecureInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Add a request interceptor
axiosBarwisSecureInstance.interceptors.request.use(
  async (config) => {
    // Do something before request is sent
    const token = await storage.get('token');
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosBarwisSecureInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.status === 401) {
      if (!noAuthPaths.includes(window.location.pathname)) {
        userStore.setRedirectToLogin(true);
        userStore.setIsAuthenticated(false);
      }
      apolloClient.resetStore();
    }
    return Promise.reject(error);
  }
);

export { axiosBarwisInstance, axiosBarwisSecureInstance };
